import Flickity from 'flickity'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default resize => {
  // const slideshow = resize.querySelector('.js-resize-slides')
  if (resize) {
    const flkty = new Flickity(resize, {
      wrapAround: true,
      cellAlign: 'left',
      adaptiveHeight: true,
      prevNextButtons: false,
      imagesLoaded: true,
      percentPosition: false
    })

    flkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    flkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      flkty.resize()
    }, 1500)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/resize.js